module.exports = __webpack_public_path__ + "img/cai1.72f5232a.png";